package com.stiv_apps.facecutweb.util

import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba

enum class Theme(
    val rgb: CSSColorValue
) {
    Text(rgb = rgb(r = 255, g = 255, b = 255)),
    TextLowVisibility(rgb = rgba(r = 255, g = 255, b = 255, a = 0.5f)),
}

val TextGradient = linearGradient(
    dir = LinearGradient.Direction.ToRight,
    from = rgb(r = 255, g = 255, b = 255),
    to = rgb(r = 225, g = 255, b = 27)
)

val BackgroundGradient = linearGradient(
    dir = LinearGradient.Direction.ToBottom,
    from = rgb(r = 37, g = 37, b = 37),
    to = rgb(r = 0, g = 0, b = 0)
)